import type { Components, Theme } from '@mui/material'

declare module '@mui/material/Badge' {
  export interface BadgePropsVariantOverrides {
    light: true
  }
}

const commonStyles = (theme: Theme) => ({
  ...theme.typography.overline,
  borderRadius: theme.shape.borderRadius,
  height: 12,
  padding: theme.spacing(0, 0.25),
  border: '1px solid',
  color: theme.palette.background.paper,
  transform: 'scale(1) translate(-50%, -50%)',
  left: 0,
  zIndex: 0,
})

export const MuiBadge = (theme: Theme): Components['MuiBadge'] => ({
  styleOverrides: {
    standard: commonStyles(theme),
  },
  variants: [
    {
      props: { variant: 'light' },
      style: {
        '.MuiBadge-badge': {
          ...commonStyles(theme),
        },
      },
    },
    {
      props: { variant: 'light', color: 'primary' },
      style: {
        '& .BaseBadge-badge': {
          backgroundColor: theme.palette.primary.lighter,
          color: theme.palette.primary.darker,
          borderColor: theme.palette.background.paper,
        },
      },
    },
    {
      props: { variant: 'light', color: 'secondary' },
      style: {
        '& .BaseBadge-badge': {
          backgroundColor: theme.palette.secondary.lighter,
          color: theme.palette.secondary.darker,
          borderColor: theme.palette.background.paper,
        },
      },
    },
    {
      props: { variant: 'light', color: 'info' },
      style: {
        '& .BaseBadge-badge': {
          backgroundColor: theme.palette.info.lighter,
          color: theme.palette.info.darker,
          borderColor: theme.palette.background.paper,
        },
      },
    },
    {
      props: { variant: 'light', color: 'success' },
      style: {
        '& .BaseBadge-badge': {
          backgroundColor: theme.palette.success.lighter,
          color: theme.palette.success.darker,
          borderColor: theme.palette.background.paper,
        },
      },
    },
    {
      props: { variant: 'light', color: 'error' },
      style: {
        '& .BaseBadge-badge': {
          backgroundColor: theme.palette.error.lighter,
          color: theme.palette.error.darker,
          borderColor: theme.palette.background.paper,
        },
      },
    },
    {
      props: { variant: 'light', color: 'warning' },
      style: {
        '& .BaseBadge-badge': {
          backgroundColor: theme.palette.warning.lighter,
          color: theme.palette.warning.darker,
          borderColor: theme.palette.background.paper,
        },
      },
    },
  ],
})
